import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { BASE_MESSAGES_API_URL, BASE_NOTIFICATIONS_API_URL, HR_NOTIFICATION_ENDPOINT } from '@app/common/api-endpoints.constants';

@Injectable({
  providedIn: 'root',
})
export class AskHrService {
  constructor(private http: HttpClient) { }

  proccessMessage(query: string): Observable<any> {
    const queryParams = new HttpParams().set('searchTerm', query);
    return this.http.get(BASE_MESSAGES_API_URL, {
      params: queryParams,
    });
  }

  sendEmail(data: any): Observable<any> {
    return this.http.post(BASE_NOTIFICATIONS_API_URL, data);
  }

  sendHrEmail(data: any): Observable<any> {
    return this.http.post(HR_NOTIFICATION_ENDPOINT, data);
  }
}

